module.exports = __webpack_public_path__ + "assets/img/shop_item.858a171e.png";